module.exports = __webpack_public_path__ + "img/abstract-circle.9040140a.svg";